import {
  customProduct,
} from './validators';

export default [
  customProduct,
];
